import { render, staticRenderFns } from "./WorkGuideDetail.vue?vue&type=template&id=7fdea670&scoped=true"
import script from "./WorkGuideDetail.vue?vue&type=script&lang=ts"
export * from "./WorkGuideDetail.vue?vue&type=script&lang=ts"
import style0 from "./WorkGuideDetail.vue?vue&type=style&index=0&id=7fdea670&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fdea670",
  null
  
)

export default component.exports